import Header from "./Header";
import { useState } from "react";

const NganHangComponent = ({ user }: any) => {
  const [showSTK, setShowSTK] = useState(false);
  const get4SoCuoiCardNumber = () => {
    return user?.cardNumber?.slice(-4);
  };
  return (
    <div className="wrapper">
      <div className="container-web themtaikhoannganhang bgnew">
        <Header title="Thêm tài khoản ngân hàng" />

        <main className="p-3">
          <div
            className="py-3 px-4 rounded-3"
            style={{ background: "#524f45" }}
          >
            <div className="d-flex justify-content-between">
              <div style={{ color: "#eecb77" }}>{user?.bankName}</div>
              <div onClick={() => setShowSTK(!showSTK)}>
                {showSTK ? (
                  <i className="fa-solid fa-eye"></i>
                ) : (
                  <i className="fa-solid fa-eye-slash"></i>
                )}
              </div>
            </div>

            <div className="d-flex justify-content-between mt-4 mb-3 ">
              {showSTK ? (
                <span>{user?.cardNumber}</span>
              ) : (
                <>
                  <span>****</span>
                  <span>****</span>
                  <span>****</span>
                  <span>{get4SoCuoiCardNumber()}</span>
                </>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default NganHangComponent;
